
<script>
export default {
  name: 'UiYoutubeView',
  props: {
    url: {}, 
  },
  computed: {
    preview() {
      return `https://img.youtube.com/vi/${this.getId(this.url)}/0.jpg`
    },
    urlComputed() {
      return `//www.youtube.com/embed/${this.getId(this.url)}?modestbranding=1;rel=0;iv_load_policy=3`
    }
  },
  methods: {
    getId(url) {
      let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
      let match = url.match(regExp)
      let eleven = 11
      if (match && match[2].length == eleven) {
        return match[2]
      }
      return new Error('error parsed link')

    },
    openPopupWithVideo() {
      let interval = 100
      setTimeout(() => {
        this.$modal.show({

          template: `
            <div>
              <iframe :src="url" allowfullscreen></iframe>
              <a class="close-popup" @click.prevent='$emit("close")'> &times; </a>
            </div>
          `,
          props: ['url'],
        }, {
          url: `//www.youtube.com/embed/${this.getId(this.url)}?modestbranding=1;rel=0;autoplay=0&mute=0;iv_load_policy=3`,
        },
        {
          classes: 'videoPopup',
          height: 'auto',
          minWidth: 300,
          maxWidth: 370,
          adaptive: true,
          scrollable: true,
        })
      }, interval)
    }

  },
  render(h) {
    return this.$scopedSlots.default({
      play: () => this.openPopupWithVideo(),
      preview: this.preview,
      urlComputed: this.urlComputed
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/js/components/Uploader/UiYoutubeView.vue